<lib-prod-form [fields]="fields" (onSubmitEvent)="submit($event)" [data]="data"
></lib-prod-form>
